const functionsConfig = { DEFAULT_REGION: 'europe-west2' };
export default functionsConfig;
